import { httpInstance } from '@/clients/http.request';
import { urlHipoteca } from '@/helpers';

export const fetchLocaciones = async ({ commit, rootState }) => {
   const id_poliza = rootState?.poliza?.poliza?.id_poliza;

   if (!id_poliza) {
      commit('setLocaciones', []);
      return [];
   }

   commit('setLoading', true);
   try {
      const { data } = await httpInstance.get(`${urlHipoteca}/locaciones`, {
         id_poliza,
      });
      commit('setLocaciones', data);
      return data;
   } finally {
      commit('setLoading', false);
   }
};

export const saveLocacion = async (
   { dispatch, rootState },
   { id_hipoteca_poliza, payload, refreshList = true },
) => {
   const id_poliza = rootState?.poliza?.poliza?.id_poliza;
   const requestPayload = { id_poliza, ...payload };

   let response;
   if (id_hipoteca_poliza) {
      response = await httpInstance.put(
         `${urlHipoteca}/locaciones/${id_hipoteca_poliza}`,
         requestPayload,
      );
   } else {
      response = await httpInstance.post(
         `${urlHipoteca}/locaciones`,
         requestPayload,
      );
   }

   if (refreshList) {
      await dispatch('fetchLocaciones');
   }
   return response.data;
};

export const fetchDocumentos = async ({ commit, rootState }) => {
   const id_poliza = rootState?.poliza?.poliza?.id_poliza;

   if (!id_poliza) {
      commit('setDocumentos', []);
      return [];
   }

   const { data } = await httpInstance.get(`${urlHipoteca}/documentos`, {
      id_poliza,
   });
   const documentos = data?.documentos ?? [];
   commit('setDocumentos', documentos);
   return documentos;
};

export const uploadDocumentos = async (_, { id_hipoteca_poliza, tipo, files }) => {
   const formData = new FormData();
   formData.append('id_hipoteca_poliza', id_hipoteca_poliza);
   formData.append('tipo', tipo);

   const fileList = Array.isArray(files) ? files : [files];
   fileList.forEach((file) => {
      formData.append('files', file);
   });

   const response = await httpInstance.post(
      `${urlHipoteca}/documentos`,
      formData,
      true,
   );
   return response.data;
};

export const removeDocumento = async ({ dispatch }, hash_id) => {
   await httpInstance.delete(
      `${urlHipoteca}/documentos?hash_id=${encodeURIComponent(hash_id)}`,
   );
   return dispatch('fetchDocumentos');
};

export const deleteLocacion = async (
   { dispatch, rootState },
   id_hipoteca_poliza,
) => {
   const id_poliza = rootState?.poliza?.poliza?.id_poliza;
   await httpInstance.delete(
      `${urlHipoteca}/locaciones/${id_hipoteca_poliza}?id_poliza=${id_poliza}`,
   );
   return dispatch('fetchLocaciones');
};
